import moment from "moment";

export const getCurrentTime = async () => {
    return moment.utc(new Date()).local().add(0, 'hours').format('HH:mm');
}
